module.exports = __webpack_public_path__ + "img/barcode-btn.67d7f4bd.svg";